import styled from 'styled-components';

interface ContainerProps {
  r: number;
  g: number;
  b: number;
  color: string;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.3% 2%;
  min-width: 712px;
  border-radius: 0px 0px 16px 0px;
  height: 112px;
  z-index: 0;
  background: rgba(
    ${(props) => props.r},
    ${(props) => props.g},
    ${(props) => props.b},
    1
  );

  .title {
    text-align: center;

    /* Heading/H3 */
    font-family: Montserrat;
    font-size: 28px;
    font-style: normal;
    font-weight: 800;
    line-height: 33.6px; /* 120% */
  }

  * {
    display: flex;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
  }
`;
